import { useNavigate } from 'react-router-dom';
import { usePatientForm } from '../context/PatientFormContext';
import PersonalInfoSection from '../components/form/PersonalInfoSection';
import FormHeader from '../components/form/FormHeader';
import { ROUTES } from '../routes';

export default function PersonalInfoPage({ onCancel }) {
  const navigate = useNavigate();
  const {
    patient,
    form,
    errors,
    setErrors,
    handleChange,
    validatePersonalInfo,
  } = usePatientForm();

  const handleNext = (e) => {
    e.preventDefault();
    const err = validatePersonalInfo();

    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    setErrors({});
    navigate(ROUTES.REGISTER_MEDICAL);
  };

  return (
    <section className="form-section">
      <div className="form-card">
        <FormHeader />

        <form onSubmit={handleNext} noValidate>
          <div className="form-step-indicator">Step 1 of 2</div>

          <PersonalInfoSection
            form={form}
            errors={errors}
            onChange={handleChange}
          />

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
            >
              Cancel
            </button>

            <button type="submit" className="btn btn-primary">
              Next
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
